export default __webpack_public_path__ + "79d5ad198c488f68825463ed822bd42d.png";